/** Макс. глубина расчёта продаж (недель) ≈ 6 месяцев хранения product / product_aggregated */
export const MAX_CALCULATION_DEPTH_WEEKS = 26;

/** Макс. период прогноза продаж (дней) ≈ 6 месяцев */
export const MAX_CALCULATION_DAY = 180;

/** Макс. глубина расчёта закупочной цены (недель) */
export const MAX_DEPTH_TO_PURCHASE_PRICE_WEEKS = 26;

export function isCalculationDepthInRange(depth: number): boolean {
  const n = Number(depth);
  return !isNaN(n) && n > 0 && n <= MAX_CALCULATION_DEPTH_WEEKS;
}

export function isCalculationDayInRange(day: number): boolean {
  const n = Number(day);
  return !isNaN(n) && n > 0 && n <= MAX_CALCULATION_DAY;
}

export function isDepthToPurchasePriceInRange(weeks: number): boolean {
  const n = Number(weeks);
  return !isNaN(n) && n > 0 && n <= MAX_DEPTH_TO_PURCHASE_PRICE_WEEKS;
}

/** Глубина в днях не меньше периода прогноза + лимит недель */
export function isCalculationDepthValid(depth: number, calculationDay: number): boolean {
  return isCalculationDepthInRange(depth) && Number(depth) * 7 >= Number(calculationDay);
}

export function isCalculationDayValid(day: number): boolean {
  return isCalculationDayInRange(day);
}

export function isDepthToPurchasePriceValid(weeks: number): boolean {
  return isDepthToPurchasePriceInRange(weeks);
}
